const RESPONSIVE_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];

function querySectionFragment(root, selector) {
  const match = root.querySelector(selector);

  if (match) {
    return match;
  }

  for (const template of root.querySelectorAll("template")) {
    const nestedMatch = querySectionFragment(template.content, selector);

    if (nestedMatch) {
      return nestedMatch;
    }
  }

  return null;
}

function imageUrlAtWidth(source, width) {
  const url = new URL(source.startsWith("//") ? `https:${source}` : source, window.location.origin);
  url.searchParams.set("width", width.toString());
  return url.href;
}

function createSecondaryImage(media, currentImage) {
  const preview = media?.preview_image;

  if (!preview?.src) {
    return null;
  }

  const image = currentImage ? currentImage.cloneNode(false) : new Image(preview.width, preview.height);
  const widths = RESPONSIVE_WIDTHS.filter((width) => width <= preview.width);

  image.alt = media.alt || "";
  image.width = preview.width;
  image.height = preview.height;
  image.src = imageUrlAtWidth(preview.src, preview.width);
  image.srcset = widths.map((width) => `${imageUrlAtWidth(preview.src, width)} ${width}w`).join(", ");
  image.loading = "lazy";
  image.fetchPriority = "low";

  if (!currentImage) {
    image.className = "product-card__image product-card__image--secondary object-fill";
  }

  return image;
}

async function updateCardSecondaryImage(input) {
  if (!input.hasAttribute("data-variant-secondary-media")) {
    return;
  }

  const card = input.closest("product-card");
  const currentImage = card?.querySelector(".product-card__image--secondary");
  const primaryImage = card?.querySelector(".product-card__image--primary");

  if (!card || !primaryImage) {
    return;
  }

  const media = JSON.parse(input.getAttribute("data-variant-secondary-media"));
  const nextImage = createSecondaryImage(media, currentImage);

  if (!nextImage || currentImage?.src === nextImage.src) {
    return;
  }

  if (!currentImage) {
    primaryImage.after(nextImage);
    card.classList.add("product-card--show-secondary-media");
    return;
  }

  currentImage.replaceWith(nextImage);
  nextImage.animate({ opacity: [0, 1] }, { duration: 150, easing: "ease-in" });
}

document.addEventListener("pointerover", (event) => {
  const label = event.target.closest(".product-card__swatch-list label, .product-card__variant-list label");
  const input = label?.control;

  if (!input?.hasAttribute("data-variant-secondary-media")) {
    return;
  }

  const media = JSON.parse(input.getAttribute("data-variant-secondary-media"));
  const preload = createSecondaryImage(media, null);

  if (preload) {
    preload.decoding = "async";
  }
}, true);

document.addEventListener("change", (event) => {
  const input = event.target.closest(".product-card__swatch-list input, .product-card__variant-list input");

  if (input) {
    updateCardSecondaryImage(input);
  }
}, true);

document.addEventListener("click", (event) => {
  const label = event.target.closest(".product-card__swatch-list label, .product-card__variant-list label");
  const input = event.target.closest(".product-card__swatch-list input, .product-card__variant-list input") || label?.control;

  if (input) {
    updateCardSecondaryImage(input);
  }
}, true);

function updateGalleryFromSection(event) {
  const fragment = event.detail?.htmlFragment;
  const form = event.target;
  const formId = form?.getAttribute?.("id");

  if (!fragment || !formId) {
    return;
  }

  const formSelector = CSS.escape(formId);
  const incomingGallery = querySectionFragment(fragment, `product-gallery[form="${formSelector}"]`);
  const incomingSwitcher = incomingGallery?.closest("[data-en-gallery-switcher]");
  const currentGallery = document.querySelector(`product-gallery[form="${formSelector}"]`);
  const currentSwitcher = currentGallery?.closest("[data-en-gallery-switcher]");

  if (incomingSwitcher) {
    const incomingKey = incomingSwitcher.getAttribute("data-gallery-key");
    const currentKey = currentSwitcher?.getAttribute("data-gallery-key");

    if (!currentSwitcher || incomingKey !== currentKey) {
      (currentSwitcher || currentGallery)?.replaceWith(incomingSwitcher);
    }
  } else if (currentSwitcher && incomingGallery) {
    currentSwitcher.replaceWith(incomingGallery);
  }
}

document.addEventListener("product:rerender", updateGalleryFromSection, true);

document.querySelectorAll("product-gallery[form]").forEach((gallery) => {
  const form = document.getElementById(gallery.getAttribute("form"));

  if (form && !form.hasAttribute("data-en-gallery-listener")) {
    form.setAttribute("data-en-gallery-listener", "true");
    form.addEventListener("product:rerender", updateGalleryFromSection);
  }
});

// Shell S3 uses one product template. Only its lower listing section is
// refreshed when the selected variant changes.
(() => {
  const controller = document.querySelector("[data-variant-listing-controller]");
  const listingSuffix = controller?.dataset.listingSectionSuffix || "listing_images_1035B_white";
  const getListingSection = () => document.querySelector(`[id$="__${listingSuffix}"]`);
  const initialListingSection = getListingSection();

  if (!initialListingSection || window.__ikaraoVariantListingControllerInitialized) {
    return;
  }

  window.__ikaraoVariantListingControllerInitialized = true;

  const legacyListingSelector = [
    "image_with_text_overlay_hqnGFY",
    "image_with_text_overlay_7ifgwh",
    "image_with_text_overlay_i9Wbkx",
    "image_with_text_overlay_NMPVXB",
    "image_with_text_overlay_jME6tq",
    "image_with_text_overlay_KX4PfG",
    "image_with_text_overlay_aRUaLT"
  ].map((id) => `[id$="__${id}"]`).join(",");

  function syncListingVisibility(variantId) {
    const listingSection = getListingSection();

    if (!listingSection || !variantId) {
      return;
    }

    const normalizedVariantId = String(variantId);
    let hasCustomListing = false;

    listingSection.querySelectorAll("[data-variant-listing-images]").forEach((listing) => {
      const isSelected = listing.dataset.variantId === normalizedVariantId;
      listing.hidden = !isSelected;

      if (isSelected && listing.dataset.hasCustomListing === "true") {
        hasCustomListing = true;
      }
    });

    listingSection.hidden = !hasCustomListing;
    listingSection.dataset.activeVariantId = normalizedVariantId;
    document.querySelectorAll(legacyListingSelector).forEach((sectionElement) => {
      sectionElement.hidden = hasCustomListing;
    });
  }

  function cleanVariantUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    url.searchParams.delete("view");
    window.history.replaceState(window.history.state, "", url.toString());
  }

  function updateListingSection(variantId) {
    if (!variantId) {
      return;
    }

    syncListingVisibility(variantId);
    cleanVariantUrl(String(variantId));
  }

  function selectedVariantId() {
    return document.querySelector('input[name="id"]')?.value
      || new URL(window.location.href).searchParams.get("variant")
      || "";
  }

  function selectedOptionLabel(position) {
    const input = document.querySelector(
      `input[type="radio"][data-option-position="${position}"]:checked`
    );

    if (!input) {
      return "";
    }

    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    return label?.textContent?.trim().toLowerCase() || "";
  }

  function matchOnlyValidWhiteCombination() {
    const targetOptionOne = controller?.dataset.targetOptionOne?.toLowerCase() || "hdmi";
    const targetOptionTwo = controller?.dataset.targetOptionTwo?.toLowerCase() || "white";

    if (
      selectedOptionLabel(2) !== targetOptionTwo
      || selectedOptionLabel(1) === targetOptionOne
    ) {
      return false;
    }

    const targetInput = [...document.querySelectorAll(
      'input[type="radio"][data-option-position="1"]'
    )].find((input) => {
      const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      return label?.textContent?.trim().toLowerCase() === targetOptionOne;
    });

    if (!targetInput) {
      return false;
    }

    document.querySelector(`label[for="${CSS.escape(targetInput.id)}"]`)?.click();
    return true;
  }

  updateListingSection(selectedVariantId());

  document.addEventListener("variant:change", (event) => {
    updateListingSection(event.detail?.variant?.id);
  });

  document.addEventListener("change", (event) => {
    if (!event.target.matches('input[type="radio"][data-option-position]')) {
      return;
    }

    window.setTimeout(() => {
      if (matchOnlyValidWhiteCombination()) {
        return;
      }

      window.setTimeout(() => {
        const variantId = document.querySelector('input[name="id"]')?.value;

        if (variantId) {
          updateListingSection(variantId);
        }
      }, 250);
    }, 0);
  }, true);

  window.setInterval(() => {
    const activeListingVariantId = getListingSection()?.dataset.activeVariantId;
    const currentVariantId = selectedVariantId();

    if (currentVariantId && currentVariantId !== activeListingVariantId) {
      updateListingSection(currentVariantId);
    }
  }, 300);
})();
